var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeechTherapyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.25,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6101 16.2155C31.6101 17.6749 30.7687 19.0465 29.3064 20.0737C27.8455 21.0999 25.8009 21.7504 23.5189 21.7504C21.2369 21.7504 19.1923 21.0999 17.7314 20.0737C16.2691 19.0465 15.4277 17.6749 15.4277 16.2155C15.4277 14.7562 16.2691 13.3846 17.7314 12.3574C19.1923 11.3312 21.2369 10.6807 23.5189 10.6807C25.8009 10.6807 27.8455 11.3312 29.3064 12.3574C30.7687 13.3846 31.6101 14.7562 31.6101 16.2155Z",
    fill: "white",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7834 24.7488C19.7834 25.2317 19.5055 25.7193 18.9542 26.1066C18.4043 26.4928 17.6181 26.7476 16.7262 26.7476C15.8343 26.7476 15.0481 26.4928 14.4982 26.1066C13.9469 25.7193 13.6689 25.2317 13.6689 24.7488C13.6689 24.2659 13.9469 23.7783 14.4982 23.391C15.0481 23.0048 15.8343 22.75 16.7262 22.75C17.6181 22.75 18.4043 23.0048 18.9542 23.391C19.5055 23.7783 19.7834 24.2659 19.7834 24.7488Z",
    fill: "white",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0925 29.0822C15.0925 29.3565 14.9349 29.6552 14.5782 29.9058C14.2229 30.1553 13.7056 30.3255 13.1107 30.3255C12.5157 30.3255 11.9985 30.1553 11.6432 29.9058C11.2865 29.6552 11.1289 29.3565 11.1289 29.0822C11.1289 28.8079 11.2865 28.5092 11.6432 28.2586C11.9985 28.0091 12.5157 27.8389 13.1107 27.8389C13.7056 27.8389 14.2229 28.0091 14.5782 28.2586C14.9349 28.5092 15.0925 28.8079 15.0925 29.0822Z",
    fill: "white",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechTherapyIcon);
export default __webpack_public_path__ + "static/media/speech-therapy-icon.999adb4fa793cb9f358f5228a6a95ab4.svg";
export { ForwardRef as ReactComponent };